<div class="dialog-header">
    <div class="dialog-header-text">Choose Avatar</div>
    <div class="cros-icon" (click)="onCancel()">
        <img src="assets/images/cross-icon.svg" class="cross-icon" />
    </div>
</div>

<div class="dialog-container">
    <div class="avatars-grid">
        <div *ngFor="let avatar of avatars" class="profile-image-container" [ngClass]="{ selected: avatar.selected }"
            (click)="selectAvatar(avatar)">
            <img [src]="avatar.imageUrl" [alt]="avatar.name" class="profile-image" />
        </div>
    </div>

    <button class="next-btn" (click)="closeDialog()" [disabled]="!hasSelectedAvatar">Next →</button>
</div>